import { render, staticRenderFns } from "./OnboardingIntegrationSmrtPhone.vue?vue&type=template&id=54290520&scoped=true&"
import script from "./OnboardingIntegrationSmrtPhone.vue?vue&type=script&lang=js&"
export * from "./OnboardingIntegrationSmrtPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54290520",
  null
  
)

export default component.exports